const initGorgiasChatPromise = window.GorgiasChat ? window.GorgiasChat.init() : new Promise((resolve)=>window.addEventListener('gorgias-widget-loaded', ()=>resolve()));
export const init = async function() {
    initGorgiasChatPromise.then(()=>{
        const container = document.querySelector('#gorgias-chat-container');
        window.GorgiasChat.on('widget:opened', ()=>{
            if (container) {
                container.classList.add('opened');
                container.classList.remove('closed');
            }
            const fontUrl = window.GORGIAS_FONT_URL;
            const timer = setInterval(()=>{
                var _document_querySelector, _iframeElement_contentWindow;
                const iframe = document;
                const iframeElement = (_document_querySelector = document.querySelector('#gorgias-chat-container')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.querySelector('#chat-window');
                if (!(iframeElement instanceof HTMLIFrameElement)) {
                    return;
                }
                const chatDoc = (_iframeElement_contentWindow = iframeElement.contentWindow) === null || _iframeElement_contentWindow === void 0 ? void 0 : _iframeElement_contentWindow.document;
                const head = chatDoc === null || chatDoc === void 0 ? void 0 : chatDoc.head;
                if (!head || !Array.from(head.children).some((el)=>el.getAttribute('data-emotion'))) {
                    return;
                }
                clearInterval(timer);
                const style = document.createElement('style');
                style.textContent = `
          @font-face {
            font-family: 'Futura PT Book';
            src: url('${fontUrl}') format('woff');
            font-display: block;
          }

          h1, h2, h3, h4, h5, h6, a, button, input, span, p, div {
            font-family: 'Futura PT Book' !important;
          }
        `;
                head.appendChild(style);
            }, 50);
        });
        window.GorgiasChat.on('widget:closed', ()=>{
            if (container) {
                setTimeout(()=>{
                    container.classList.add('closed');
                    container.classList.remove('opened');
                }, 500);
            }
        });
        window.addEventListener('drawer:expanded', (e)=>{
            window.GorgiasChat.close();
        });
    });
};
